export default __webpack_public_path__ + "static/media/2l.7c9569ef.svg";